export const VOD_CONTENT_TYPE = "vod";
export const TV_CONTENT_TYPE = "tv";
export const RECORDING_CONTENT_TYPE = "recording";
